import { useState, useRef, useEffect, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import AddCustomSupplyPopup from '@/pages/comp/supply/supply/popup/add_custom_supply';
import SearchArea from '@/pages/comp/basic/student/list/area/search_area';
import SearchSupplyArea from "./area/search_supply";
import SumTableArea from "./area/sum_table";
import { useSelector, useDispatch } from 'react-redux';
import PageListFunc from "./func/list_func";

function SupplyMultyAddArea() {
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const listAggridRef = useRef<any>();
  let now_ymd_str = DateFunc.get_date_format(new Date(), "Y-m-d");
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    order_id: "a_stu_supply_day, a_stu_grade, a_user_name",
    s_addon_class_supply: "1",
    s_supply_date_type: 'a_date',
    s_supply_start_date: DateFunc.get_date_format(new Date(), "Y-m-01"),
    s_supply_end_date: DateFunc.get_date_format(new Date(), "Y-m-t"),
    s_supply_state: "",
    s_supply_sort: "",
    s_grade: ["student"],
    s_addon_class_user: "1",
    s_addon_class_user_is_addon_supply_data:"1",
    s_addon_class_user_supply_year:DateFunc.get_date_format(new Date(), "Y"),
    s_addon_class_user_supply_month:DateFunc.get_date_format(new Date(), "m"),
    s_stu_lecture_seq: "",//user.user_grade == "master" ? "" : strFunc.get_storage_array("s_stu_lecture_seq", "", ",")
    // s_attend_sort_detail: "",
    // s_attend_start_date: now_ymd_str,
    // s_attend_end_date: now_ymd_str,
    // s_addon_link_user:"1",
    // s_addon_profile:"1",
  });
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "add_custom_supply",//add_custom_supply
    title: "팝업",
    stu_seq_arr: [],
    supply_row_data: {},
    width: "800px",
    height: "100%",
  });

  useEffect(() => {

  }, []);

  const list = (inOptObj: any) => {
    let tmp_list_opt:any = { ...listOpt, ...inOptObj };
    tmp_list_opt["sc"] = listAggridRef.current.getListSc();
    setListOpt(tmp_list_opt);
    
    tmp_list_opt.s_addon_class_user_supply_year=tmp_list_opt.s_supply_start_date.substring(0,4);
    tmp_list_opt.s_addon_class_user_supply_month=tmp_list_opt.s_supply_start_date.substring(5,7);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          //합계금액
          let tmp_info_arr = response.data["data"]["info_arr"];
          tmp_info_arr=PageListFunc.get_info_arr_added_money_sum({ infoArr: tmp_info_arr });
          tmp_info_arr=PageListFunc.get_ordered_by_supply({ infoArr: tmp_info_arr });
          setInfoArr(tmp_info_arr);
          setCountInfo(response.data["data"]["count_info"]);
          listAggridRef.current.setInfoArr(tmp_info_arr);
        } else {

        }
      });
  };

  const goWriteSupply = (inData:any) => {
    let opt_obj={
      selected_rows:listAggridRef.current.getSelectedRows(),
      ...inData
    };
    let selected_rows = opt_obj.selected_rows;
    if (selected_rows.length === 0) {
      alert("선택없음.");
      return false;
    }
    //체크해보기


    let confirm_msg = selected_rows.length + "명의 수납등록을 하시겠습니까?";

    if (!confirm(confirm_msg)) {
      return false;
    }
    let stu_seq_arr = [];
    for (let i = 0; i < selected_rows.length; i++) {
      stu_seq_arr.push(selected_rows[i]["a_seq"]);
    }
    let add_supply_data = {
      "stu_seq_arr": stu_seq_arr,
      "supply_year": listOpt.s_supply_start_date.substring(0, 4),
      "supply_month": listOpt.s_supply_start_date.substring(5, 7),
      "supply_sort": "class",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/add_by_student', add_supply_data, get_axios_data())
      .then((response) => {
        alert(response.data["msg"]);
        if (response.data["result"] === "true") {
          list({});
        } else {

        }
      });
  };

  const open_supply_custom_popup = () => {
    let selected_row = listAggridRef.current.getSelectedRows();

    let stu_seq_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let select_row_data = selected_row[i];
      stu_seq_arr.push(select_row_data["a_seq"]);
    }

    let supply_row_data = {};
    let pop_title = "청구서 커스텀 추가";

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": pop_title,
      "sort": "add_custom_supply",
      stu_seq_arr: stu_seq_arr,
      supply_row_data: supply_row_data,
    });
  };

  const cellClickedListener = useCallback((params: any) => {
    var key = params.colDef.field;
    if (key == "a_name") {

    }
  }, []);

  const cellRenderer = (params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;

    if (key == "row_view_class_name") {
      if (params.data.class_arr) {
        let class_name_arr = [];
        for (let i = 0; i < params.data.class_arr.length; i++) {
          class_name_arr.push(params.data.class_arr[i]["class_name"]);
        }
        render_str = class_name_arr.join(" / ");;
      }
    } else if (key == "row_view_class_money") {
      if (params.data.class_arr) {
        let class_name_arr = [];
        for (let i = 0; i < params.data.class_arr.length; i++) {
          if (params.data.class_arr[i]["class_info"]) {
            let class_info = params.data.class_arr[i]["class_info"];
            if (class_info["a_supply_money"]) {
              class_name_arr.push(strFunc.comma(class_info["a_supply_money"]));
            }
          }
        }
        render_str = class_name_arr.join(" / ");;
      }
    } else if (key == "row_view_manage") {
      render_str = (
        <div>
          <button className="btn-s btn-dark" 
            onClick={() => { 
              goWriteSupply({
                selected_rows: [params.data]
              });
             }} >수납생성</button>
        </div>
      );
    } else if (key == "row_view_supply_cnt") {
      if (params.data.supply_arr) {
        render_str = params.data.supply_arr.length + " 건";
      }
    } else if (key == "row_view_supply_money") {
      if (params.data.supply_data) {
        render_str = strFunc.comma(params.data.supply_data.a_money);
      }
    } else if (key == "a_stu_supply_discount") {
      if (params.data.supply_data) {
        render_str = strFunc.comma(params.data.supply_data.a_discount_money);
      }
    }else if(key=="row_view_supply_money_sum"){
      if (params.data.supply_data) {
        render_str = strFunc.comma(params.data.supply_data.a_money_sum);
      }
    } else if (key == "row_view_added_supply") {
      render_str = strFunc.comma(params.data.added_supply_money_sum);
    }

    return render_str;
  };

  return (
    <div>
      <div>
        <SearchArea
          listOpt={listOpt}
          setListOpt={setListOpt}
          xColumnArr={{ ...xColumnArr }}
          list={list}
          is_show_class_search={true}
        ></SearchArea>
        <SearchSupplyArea
          listOpt={listOpt}
          goWriteSupply={goWriteSupply}
          open_supply_custom_popup={open_supply_custom_popup}
          list={list}
        ></SearchSupplyArea>
        <SumTableArea infoArr={infoArr}></SumTableArea>
      </div>
      <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          onChangeNumPerPage={(num_per_page: number) => { list({ num_per_page: num_per_page, now_page: 1 }); }}></Paging>
      <ListAggrid
        ref={listAggridRef}
        infoArr={infoArr}
        xColumnArr={{ ...xColumnArr }}
        list={list}
        gridOpt={{
          fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
          is_idx_num: true,
          is_add_checkbox: true,
          floatingFilter: false,
          domLayout: 'autoHeight',
          onGridReady: () => {
            list({});
          },
          onCellClicked: cellClickedListener,
          cellRenderer: cellRenderer
        }}
      ></ListAggrid>
      <div className="mt-1">
        <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          onChangeNumPerPage={(num_per_page: number) => { list({ num_per_page: num_per_page, now_page: 1 }); }}></Paging>
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "add_custom_supply" &&
            <AddCustomSupplyPopup
              stu_seq_arr={popupData.stu_seq_arr}
              supply_row_data={popupData.supply_row_data}
              refresh_data={list}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></AddCustomSupplyPopup>
          }
        </LayerPopup>
      }
    </div>
  );
}

export default SupplyMultyAddArea;